const LANGUAGE_DISPLAY_NAME_OVERRIDES: Record<string, string> = {
  French: 'French',
};

const LANGUAGE_CODE_DISPLAY_NAME_OVERRIDES: Record<string, string> = {
  fr: 'French',
};

export const getLanguageDisplayName = (
  languageName: string,
  languageCode?: string
): string => {
  if (LANGUAGE_DISPLAY_NAME_OVERRIDES[languageName]) {
    return LANGUAGE_DISPLAY_NAME_OVERRIDES[languageName];
  }

  if (languageCode && LANGUAGE_CODE_DISPLAY_NAME_OVERRIDES[languageCode]) {
    return LANGUAGE_CODE_DISPLAY_NAME_OVERRIDES[languageCode];
  }

  return languageName;
};
